import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import PageTitle from '../Layout/PageTitle';
import { leadership, faculty } from '../data/teachersData';
import './Teachers.css';

const Teachers = () => {
	useEffect(() => {
		document.body.setAttribute('data-theme-color', 'color_1');
	}, []);

	return (
		<Fragment>
			<Header />
			<div className="page-content teachers-page">
				<PageTitle motherMenu="Our Team" activeMenu="Teachers" />

				<section className="teachers-intro">
					<div className="container">
						<span className="teachers-intro__eyebrow">Bright Future School</span>
						<h1 className="teachers-intro__title">Meet the People Who Shape Our Future</h1>
						<p className="teachers-intro__text">
							Our dedicated educators and leadership team work together to nurture every child with
							care, creativity, and a commitment to excellence.
						</p>
					</div>
				</section>

				<section className="teachers-leadership">
					<div className="container">
						<div className="teachers-section-head">
							<h2>Our Leadership</h2>
							<p>Visionary leaders guiding Bright Future School toward excellence in education.</p>
						</div>
						<div className="leadership-grid">
							{leadership.map((person) => (
								<article className="leadership-card" key={person.name}>
									<div className="leadership-card__media">
										<img src={person.image} alt={person.name} />
										<span className="leadership-card__role">{person.role}</span>
									</div>
									<div className="leadership-card__body">
										<h3 className="leadership-card__name">{person.name}</h3>
										<p className="leadership-card__desc">{person.description}</p>
										{person.detailLink && (
											<Link to={person.detailLink} className="leadership-card__link">
												View profile <i className="fa fa-arrow-right" />
											</Link>
										)}
									</div>
								</article>
							))}
						</div>
					</div>
				</section>

				<section className="teachers-faculty">
					<div className="container">
						<div className="teachers-section-head">
							<h2>Our Faculty</h2>
							<p>
								Qualified and caring teachers who ensure every child receives the personal attention
								they deserve.
							</p>
						</div>
						<div className="faculty-grid">
							{faculty.map((teacher) => (
								<article className="faculty-card" key={teacher.name}>
									<div className="faculty-card__photo">
										<img src={teacher.image} alt={teacher.name} />
									</div>
									<div className="faculty-card__info">
										<h4 className="faculty-card__name">{teacher.name}</h4>
										{teacher.role ? (
											<span className="faculty-card__role">{teacher.role}</span>
										) : (
											<span className="faculty-card__role faculty-card__role--empty">Faculty</span>
										)}
									</div>
								</article>
							))}
						</div>
					</div>
				</section>
			</div>
			<Footer />
		</Fragment>
	);
};

export default Teachers;
